<template>
  <div class="batch-upload-btn">
    <a @click="importSelect">批量导入被保人</a>
    <input type="file" class="faraway import-file" accept=".xls,.xlsx" @change="importChange">
  </div>
</template>


<script>
import utils from '@/libs/utils';
import insuranceOcrDialog from '@/pages/insurance/components/insurance-ocr-dialog';

export default {
  props: {
    insuranceData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    insuranceOcrDialog,
  },
  data() {
    return {
      showOcrDialog: false,
    };
  },
  methods: {
    // 点击导入
    importSelect() {
      if (!window.XLSX) return utils.msg.error('引入解析模块失败');
      this.$el.querySelector('.import-file').click();
    },
    // 选择文件发生变化
    importChange(e) {
      if (!e.target.files[0]) return;
      this.uploadLoading = this.$loading();

      const file = e.target.files[0];

      const fileReader = new FileReader();
      fileReader.onload = () => {
        e.target.value = '';

        try {
          const sheets = XLSX.read(fileReader.result, { type: 'binary' }).Sheets;

          if (!sheets['团单上传标准格式']) {
            this.uploadLoading.close();

            return utils.msg.error('无法识别表格内容，请参照文档模板进行填写');
          }

          this.importAction(sheets['团单上传标准格式']);
        } catch (err) {
          this.uploadLoading.close();

          utils.msg.error('无法识别表格内容，请参照文档模板进行填写');
        }
      };
      setTimeout(() => {
        fileReader.readAsBinaryString(file);
      }, 100);

    },
    
    // 导入
    importAction(sheets) {
      let errs = 0;

      if (!sheets.B5 || sheets.B5.w !== '姓名') errs = 1;
      if (!sheets.C5 || sheets.C5.w !== '证件类型（1-身份证，2-护照）') errs = 1;
      if (!sheets.D5 || sheets.D5.w !== '证件号码') errs = 1;
      if (!sheets.E5 || sheets.E5.w !== '出生日期') errs = 1;
      if (!sheets.F5 || sheets.F5.w !== '性别') errs = 1;

      if (errs) {
        this.uploadLoading.close();
        return utils.msg.error('无法识别表格内容，请参照文档模板进行填写');
      }
      const xlsFieldMap = {
        B: 'cname',
        C: 'card_type',
        D: 'card_code',
        E: 'birthday',
        F: 'sex',
      };
      let xlsData = [];
      const length = 200; // 最多两百条，直接把这两百条的数据都取出来
      for (let n = 0; n < length; n++) {
        const rowItem = {};
        Object.keys(xlsFieldMap).forEach((field) => {
          const fieldValue = sheets[field + (n + 6)] ? sheets[field + (n + 6)].w.trim() : '';
          rowItem[xlsFieldMap[field]] = fieldValue;
        });
        xlsData.push(rowItem);
      }
      // 清除空行
      xlsData = xlsData.filter((item) => {
        let flag = false;
        flag = Object.keys(xlsFieldMap).some(field => item[xlsFieldMap[field]]);
        return flag;
      });

      // 格式化数据
      xlsData = xlsData.map((item) => {
        item.cname = item.cname ? item.cname.replace(/ /g, '') : '';
        item.cname = item.cname.length <= 15 ? item.cname : '';
        item.ename = PinyinHelper.convertToPinyinString(item.cname, '', PinyinFormat.WITHOUT_TONE);
        item.card_type = +item.card_type || '';
        const dateReg = /^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/;
        item.birthday = dateReg.test(item.birthday) ? new Date(item.birthday) : '';
        const sexMap = {
          男: '1',
          女: '0',
        };
        item.sex = sexMap[item.sex] ? +sexMap[item.sex] : undefined;
        if (this.insuranceData.applicant_type === 1 && item.card_type === 2) {
          // 只支持身份证，把护照的选择清空
          item.card_type = '';
          item.card_code = '';
        } else if (this.insuranceData.applicant_type === 2 && item.card_type === 1) {
          // 只支持护照，把身份证的选择清空
          item.card_type = '';
          item.card_code = '';
        }

        item.relation_id = this.insuranceData.is_self_insure ? 1 : undefined;
        return item;
      });


      if (!xlsData.length) {
        this.uploadLoading.close();
        return utils.msg.warning('未导入任何申请人，请将信息填入表格');
      } 
      
      // 最后一条数据是否为空，为空则删除
      const lastInsurance = this.insuranceData.insurants[this.insuranceData.insurants.length - 1];
      const lastInsurantIsEmpty = Object.keys(lastInsurance).every(key => lastInsurance[key] !== 0 && !lastInsurance[key]);
      // 当前长度
      const currLength = lastInsurantIsEmpty ? this.insuranceData.insurants.length - 1 : this.insuranceData.insurants.length;
      if (currLength + xlsData.length > this.insuranceData.max_people) {
        this.uploadLoading.close();
        return utils.msgbox.alert(`本商品最多可上传(${this.insuranceData.max_people}人)，请修改后重新上传`, '系统提示', { confirmButtonText: '知道了' });
      }

      utils.msg.success('文件上传成功，请确认列表信息');
      this.uploadLoading.close();
      this.$emit('batch-upload', xlsData);
    },


  },
};

</script>


<style lang="less" scoped>
.batch-upload-btn{
  display: flex;
  align-items: center;
}
a{
  color: #599FFF;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/theInsured-list/components/batch-upload-btn.vue